import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects das telas antigas (strangler) para os destinos vivos.
 * O acompanhamento (dashboards da antiga Análise de Bots) agora é a tela
 * `/orquestrador`; o navegador de logs é a aba Logs de `/automacao`.
 */

// Antigo /analise-bots (dashboards de analise) -> substituido pela tela /orquestrador
export const RedirectToAnalise = () => <Navigate to="/orquestrador" replace />;

// Antigo /monitoramento (navegador de logs) -> aba Logs de /automacao
export const RedirectToLogs = () => <Navigate to="/automacao?secao=logs" replace />;

// Permissões saíram das telas espalhadas e ficam todas na Central de Permissões.
export const RedirectPermissoesDoGrupo = () => {
  const { itemId } = useParams();
  return <Navigate to={`/configuracoes/permissoes?grupo=${itemId ?? ''}`} replace />;
};

export const RedirectPermissoesEventos = () => (
  <Navigate to="/configuracoes/permissoes?aba=kanban" replace />
);

export const RedirectTelasDoSistema = () => (
  <Navigate to="/configuracoes/permissoes/catalogo" replace />
);
